<template>
    <div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="轮播图配置" name="first">
                <SwiperConfig ref="swiper-config"></SwiperConfig>
            </el-tab-pane>
            <el-tab-pane label="店铺详情配置" name="second">
               <ShopConfig ref="shop-config"></ShopConfig>
            </el-tab-pane>
            <el-tab-pane label="公告内容配置" name="third">
                <noticeConfig ref="notice-config"></noticeConfig>
                <!-- <span style="font-size:12px;color:rgba(0, 0, 0, 0.7)">说明：该模块配置小程序首页公告信息，最多同时激活3则公告</span> -->
            </el-tab-pane>
            <!-- <el-tab-pane label="常见问题配置" name="fourth">
                <span style="font-size:12px;color:rgba(0, 0, 0, 0.7)">说明：该模块配置小程序我的服务常见问题模块，用于解答相关用户常见问题</span>
            </el-tab-pane> -->
        </el-tabs>

    </div>
   
</template>
<script>
import SwiperConfig from './children/SwiperConfig.vue';
import ShopConfig from './children/ShopConfig.vue';
import noticeConfig from './children/noticeConfig.vue';
export default {
    data() {
      return {
          pageNo:1,
          pageSize: 10,
          activeName: 'first',
          addDialogVisible: false,
      }
    },
    components: {
        SwiperConfig,
        ShopConfig,
        noticeConfig
    },
    created() {

    },
    methods: {
        handleClick(tab, event) {
            console.log(tab, event);
        },
    }
}
</script>

<style>

</style>